"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiniProviderContent = void 0;
var MiniProviderContent_1 = require("./MiniProviderContent");
Object.defineProperty(exports, "MiniProviderContent", { enumerable: true, get: function () { return __importDefault(MiniProviderContent_1).default; } });
//# sourceMappingURL=index.js.map